var childWidthCalculator = {
    init: function () {
        let containers = document.querySelectorAll(".js-child-width-container");
        if(containers) {
            containers.forEach(el => 
                {
                    // Min
                    var childrenMin = el.querySelectorAll(".js-child-width-min");
                    if(childrenMin)
                    {
                        var maxWidth = 0;
                        childrenMin.forEach(function(child) {
                            maxWidth = Math.max(maxWidth, child.offsetWidth);
                        });

                        if(maxWidth > 0)
                        {
                            // We add 1 pixel since it might calculate 77.33 pixels in some cases
                            maxWidth = maxWidth + 1;
                            childrenMin.forEach(function(child) {
                                child.style.minWidth = maxWidth + 'px';
                            });
                        }
                    }

                    // Max
                    var childrenMax = el.querySelectorAll(".js-child-width-max");
                    if(childrenMax)
                    {
                        var maxWidth = 0;
                        childrenMax.forEach(function(child) {
                            maxWidth = Math.max(maxWidth, child.offsetWidth);
                        });

                        if(maxWidth > 0)
                        {
                            // We add 1 pixel since it might calculate 77.33 pixels in some cases
                            maxWidth = maxWidth + 1;
                            childrenMax.forEach(function(child) {
                                child.style.maxWidth = maxWidth + 'px';
                            });
                        }
                    }

                    // Width
                    var children = el.querySelectorAll(".js-child-width");
                    if(children)
                    {
                        var maxWidth = 0;
                        children.forEach(function(child) {
                            maxWidth = Math.max(maxWidth, child.offsetWidth);
                        });

                        if(maxWidth > 0)
                        {
                            // We add 1 pixel since it might calculate 77.33 pixels in some cases
                            maxWidth = maxWidth + 1;
                            children.forEach(function(child) {
                                child.style.width = maxWidth + 'px';
                            });
                        }
                    }

                }
            );
        }
    }
}

export default childWidthCalculator;